import React, { useState, useContext } from "react";
import { Controller } from "react-hook-form";
import { IonLabel, IonItem, IonSelect, IonSelectOption } from "@ionic/react";
import useDeepCompareEffect from "use-deep-compare-effect";
import { getSystemTableData } from "../../api/server";
import RestrictedContext from "../util/RestrictedContext";
import SkeltonItemContent from "./SkeltonItemContent";
import { useIntl } from "react-intl";

const SelectItem = (props) => {
  const {
    name,
    control,
    rules,
    label,
    disabled,
    type,
    category,
    params,
    identfierId,
    loading,
    ...rest
  } = props;
  const intl = useIntl();
  const [data, setData] = useState([]);
  const restricted = useContext(RestrictedContext);
  const options = {
    cssClass: "select-interface",
  };
  useDeepCompareEffect(() => {
    getSystemTableData({ ...params }).then(({ error, data }) => {
      if (data) {
        setData(data.items);
      }
    });
  }, [params, {}]);

  const identfier = identfierId ? identfierId : "name";
  return loading ? (
    <IonItem>
      <SkeltonItemContent />
    </IonItem>
  ) : (
    <IonItem>
      <IonLabel position="floating">{label}</IonLabel>
      <Controller
        control={control}
        rules={rules}
        render={({ field }) => {
          const { onChange, onBlur, value } = field;
          return (
            <IonSelect
              {...rest}
              interfaceOptions={options}
              value={value}
              disabled={disabled || !restricted["hasWritePermission"]}
              onIonChange={(e) => onChange(e.detail.value)}
              type={type}
              onBlur={onBlur}
              okText={intl.formatMessage({
                id: "app.mobile.actions.approve",
              })}
              cancelText={intl.formatMessage({
                id: "app.mobile.actions.cancel",
              })}
            >
              {data.map((option) => {
                return (
                  <IonSelectOption
                    key={option[identfier]}
                    value={option[identfier]}
                  >
                    {option.name}
                  </IonSelectOption>
                );
              })}
            </IonSelect>
          );
        }}
        name={name}
      />
    </IonItem>
  );
};

export default SelectItem;
